import * as _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import FindClientDialog from  'src/components/client-project/dialogs/FindClientDialog';
import { ITableConfig } from 'src/components/common/table';
import useFetch from 'use-http';
import CPNavBar from '../CPNavBar';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
// import Select from 'react-select';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import { SelectItem } from 'src/models/common/SelectItem';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import TagContainer from 'src/components/counties/TagContainer';
import State from 'src/models/State';
import County from 'src/models/County';
import Button from 'src/components/controls/forms/redesign/FormButton';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import PagedResultSet from 'src/models/common/PagedResultSet';
import TsdiClient from 'src/models/AP/Client';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { MdHistory } from 'react-icons/md';
import { FaTrash } from 'react-icons/fa';
import { FaUserTie } from 'react-icons/fa';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { FaFileAlt } from 'react-icons/fa';
import { VscGraph } from 'react-icons/vsc';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import FindProjectDialog from '../dialogs/FindProjectDialog';
import TsdiOffice from 'src/models/AP/TsdiOffice';
import Landman from 'src/models/Landman';
import FindManagerDialog from 'src/components/project-billing/dialogs/FindManagerDialog';
import PersonnelToast from 'src/components/personnel/components/PersonnelToast';

const ProjectMaintenancePage = () => {
    const dispatch = useDispatch();
    // const { get, post, del, put, response } = useFetch();
    // const { register, reset, setValue, getValues, handleSubmit, errors, formState } = useForm();
    const { register: registerState, /*reset: resetState*/ } = useForm();
    const { register, errors, reset, getValues, setValue} = useForm();
    const { register: registerClientValues, reset: resetClientValues } = useForm();
    const { get, post, put, response } = useFetch();
    const [projects, setProjects] = useState<ProspectDetails[]>(undefined);
    const [projectTypes, setProjectTypes] = useState<{ code: number, description: string}[]>(undefined);
    const [currentMileageRate, setCurrentMileageRate] = useState<number>(undefined);
    const [selectedState, setSelectedState] = useState<number>(undefined);
    const [clientStateId, setClientStateId] = useState<number>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [stateCounties, setStateCounties] = useState<PagedResultSet<County>>(undefined);
    const [selectStates, setSelectStates] =  useState<Array<{ value: string; label: string }>>(undefined);
    const [selectStateCounties, setSelectStateCounties] = useState<Array<SelectItem>>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [projectSearchOptions, setProjectSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>('');
    const [projectSearchTerm, setProjectSearchTerm] = useState<string>('');
    const [fetchNextClientsPage, setFetchNextClientsPage] = useState<boolean>(true);
    const [fetchNextProjectsPage, setFetchNextProjectsPage] = useState<boolean>(true);
    const [applyBdBonus, setApplyBdBonus] = useState<boolean>(false);
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [selectedProject, setSelectedProject] = useState<ProspectDetails>(undefined);
    const [addingProject, setAddingProject] = useState<boolean>(false);
    const [saveCountiesRef, setSaveCountiesRef] = useState<HTMLButtonElement>(null);
    const [countiesForUpdate, setCountiesForUpdate] = useState<Array<County>>(null);
    const [officeOptionValues, setOfficeOptionValues] = useState<{ code: string, description: string}[]>(undefined);
    const [billByOptions, setBillByOptions] = React.useState<Array<{ value: number, label: string}>>(undefined);
    const [offices, setOffices] = useState<Array<TsdiOffice>>(undefined);
    const [managers, setManagers] = useState<Landman[]>(undefined);
    const [toast, setToast] = useState<{ message: string; color?: string, persistent?: boolean; } | null>(null);
    // const { isDirty, dirtyFields } = formState;

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (Array.isArray(offices) && offices.length > 0) {
            setOfficeOptionValues(offices.map((o: TsdiOffice, index) => { return { code: o?.id ? o.id.toString() : index.toString(), description: o?.office}; }));
        }
    }, [offices]);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!projectSearchOptions) {
            getProjects();
        }
    }, [projectSearchOptions]);

    useEffect(() => {
        if (!!countiesForUpdate) {
            updateProject(generateUpdatePayload());
        }
    }, [countiesForUpdate]);

    useEffect(() => {
        if (!!addingProject) {
            showDialog(DialogList.FIND_PROJECT);
        }
    }, [addingProject]);

    useEffect(() => {
        if (selectedClient) {
            console.log(selectedClient?.clientNumber);
        }
    }, [selectedClient]);

    useEffect(() => {
        if (states?.items?.length) {

            let list = states?.items?.map(s => {
                return {
                    label: (!!s.name ? `(${s.name})` : ''),
                    value: `${s.id}` };
            });
            setSelectStates(list);
        }
    }, [states]);

    useEffect(() => {
        if (!!selectStates) {
            console.log(selectStates[0]);
        }
    }, [selectStates]);

    useEffect(() => {
        if (!!stateCounties && stateCounties?.items?.length > 0) {
            setSelectStateCounties(stateCounties ? stateCounties?.items?.map((c: County) => new SelectItem(c.id, c.name)) : undefined);
        }
    }, [stateCounties]);

    useEffect(() => {
        if ((!!clientSearchTerm || clientSearchTerm === '') && !!clientSearchOptions) {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if ((!!projectSearchTerm || projectSearchTerm === '') && !!projectSearchOptions) {
            resetProjectSearchOptions();
        }
    }, [projectSearchTerm]);

    useEffect(() => {
        getClients();
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!clients && clients.length > 0) {
            prepFormData();
            getStatesCounties(clientStateId);

            const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
            const storedClientName = localStorage.getItem('backOfficeSelectedClientName');
            if (!!storedClientNumber && !isNaN(Number(storedClientNumber)) && !!storedClientName) {
                const clientToRestore = clients.find((c) => c.clientNumber === Number(storedClientNumber));
                if (clientToRestore) {
                    setSelectedClient(clientToRestore);
                }
            }
        }
    }, [clients]);

    useEffect(() => {
        if (Array.isArray(projects) && projects.length > 0) {
            const storedProjectNumber = localStorage.getItem('backOfficeSelectedProjectNumber');
            const storedProjectName = localStorage.getItem('backOfficeSelectedProjectName');
            if (storedProjectNumber && !isNaN(Number(storedProjectNumber)) && storedProjectName) {
                const projectToRestore = projects.find((p) => p.number === Number(storedProjectNumber));
                if (projectToRestore) {
                    setSelectedProject(projectToRestore);
                }
            }
        }
    }, [projects]);

    useEffect(() => {
        if (!!selectedClient) {
            if (!!clients && clients?.length > 0) {
                resetClientValues({ clientNumber: selectedClient?.clientNumber, clientName: selectedClient?.clientName });
            }
            getStatesCounties(clientStateId);
            getProjects();
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!selectedProject) {
            populateProjectForm();
            if (!!selectedClient?.clientNumber && !!selectedClient?.clientName) {
                resetClientValues({ clientNumber: selectedClient.clientNumber, clientName: selectedClient.clientName});
            }
        }
    }, [selectedProject]);

    useEffect(() => {
        if (!!selectedState) {
            // resetState({ value: selectedState, label: });
            console.log(selectedState);
        }
    }, [selectedState]);

    const onCreate = () => {
        // Put all initialization code here.
        console.log(officeOptionValues);
        setClientStateId(40);
        initializeClientSearchSettings();
        getStates();
        getManagers();
        getClientTypes();
        if (!projects) {
            setProjects([]);
        }
        getBillbyOptions();
        getCurrentMileageRate();
        const saveCountiesButtonRef = document.getElementById('saveCountiesButton') as HTMLButtonElement;
        if (!!saveCountiesButtonRef) {
            setSaveCountiesRef(saveCountiesButtonRef);
        }

        const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
        const storedClientName = localStorage.getItem('backOfficeSelectedClientName');
        if (!!storedClientNumber && !isNaN(Number(storedClientNumber)) && !!storedClientName) {
            setClientSearchTerm(storedClientNumber);
        }
        getOffices();
    };

    const getProjects = async () => {
        if (clients === undefined || clients?.length < 1) {
            return;
        }
        const clientIndex = clients?.findIndex((c) => c?.clientNumber === selectedClient?.clientNumber);
        if (clientIndex === -1) {
            return;
        }
        let result = await get(`/v1.0/ClientProjectMaintenance/projects/byclient/${clients[clientIndex].clientNumber}`);

        if (response.ok) {
            setProjects([]);
            setProjects(result);
        } else {
            setProjects([]);
            console.log('Unable to get client data!');
        }
    };

    const getBillbyOptions = async () => {
        // Checks `result` (this call's own resolved body), not the shared useFetch() `response` -
        // onCreate fires several get() calls concurrently off one shared hook instance, so
        // `response.ok` here could reflect a different, later-resolving fetch and silently skip
        // setBillByOptions even though this call actually succeeded (2026-09-14: this is what let
        // the "Add Project" dialog fall through to its hardcoded, broken BillBy fallback list).
        const result = await get(`/v1.0/ClientProjectMaintenance/billing/billby/options`);

        if (Array.isArray(result) && result.length > 0) {
            setBillByOptions(result.map((bbo: { code: number, description: string}) => {
                return { value: bbo.code, label: bbo.description };
            }));
        }
    };

    const getCurrentMileageRate = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/billing/mileagerate/current`);

        if (response.ok) {
            setCurrentMileageRate(result);
        } else {
            setCurrentMileageRate(.7);
            console.log('Unable to get mileage rate!');
        }
    };

    const onDestroy = () => {
        // Put all destruction code here.
    };

    const hideDialog = () => {
        setAddingProject(false);
        dispatch(actions.layout.hideDialog());
    };

    const onCancel = () => {
        setAddingProject(false);
        dispatch(actions.layout.hideDialog());
    };

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
            // Todo: get this from the DB and set it when the client is set from FindClientsDialog
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

    const prepFormData = () => {
        if (!!clients && clients?.length > 0) {
            console.log(clients[0]);
        }
    };

    const populateProjectForm = () => {
        const resetProject = _.cloneDeep(selectedProject);
        setApplyBdBonus(resetProject.bdBonus);
        resetProject.managingOffice = getOfficeIdString(resetProject.managingOffice);
        reset(resetProject);
        // setValue('managingOffice', '106');
        setValue('type', selectedProject.type);
        setValue('clientLandmanUse', selectedProject?.clientLandmanUse ? selectedProject?.clientLandmanUse : 0);
        setValue('hideProspectOnInvoice', selectedProject.hideProspectOnInvoice ? selectedProject.hideProspectOnInvoice : 0);
    };

    const onStateSelected = (id: number) => {
        setSelectedState(id);
        getStatesCounties(id);
    };

    const getStatesCounties = async (id: number) => {
        const result = await get(`/v1.0/States/${id}/counties`);

        if (result) {
            setStateCounties(result);
        } else {
            console.log('Unable to retrieve the Counties for selected State.');
        }
    };

    const getStates = async () => {
        const result = await get(`/v1.0/states`);

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to retrieve States data.');
        }
    };

    const deleteProject = () => {
        alert('Delete a project');
    };

    const displayTitle = () => {
        const title = 'Project Maintenance';

        return title;
    };

    const displayHeading2 = () => {
        const title = 'Project Settings';

        return title;
    };

    const addProject = async (payload: ProspectDetails) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/project`, payload);

        if (response.ok && result > 0) {
            getProject(selectedClient?.clientNumber, result);
            getProjects();
            const newClient = _.cloneDeep(selectedClient);
            setSelectedClient(newClient);
        } else {
            showToast('Add project failed: ' + response.data, `rgba(255,0,0,0.5)`);
        }
    };

    const getProject = async (clientNumber: number, projectNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/project/${projectNumber}/client/${clientNumber}`);

        if (response.ok) {
            setSelectedProject(result);
        }
    };

    const updateProject = async (payload: ProspectDetails) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/project`, payload);

        if (response.ok && result === 1) {
            getProject(selectedClient?.clientNumber, selectedProject?.number);
        }
    };

    const getClientTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/types`);
        setProjectTypes([]);
        if (response.ok) {
            setProjectTypes(result);
        }
    };

    const getOffices = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/offices`);

        if (response.ok) {
            setOffices([]);
            setOffices(result);
        } else {
            setOffices([]);
            console.log('Unable to get TSDI Office data!');
        }
    };

    const resetClientSearchOptions = () => {
        setFetchNextClientsPage(true);
        console.log(fetchNextClientsPage);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        if (typeof clientSearchTerm === 'string') {
            const fieldValues = clientSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
            }
            if (fieldValues[5] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
            }
            if (fieldValues[6] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
            }
        }
        setClientSearchOptions(newClientSearchOptions);
    };

    const resetProjectSearchOptions = () => {
        setFetchNextProjectsPage(true);
        console.log(fetchNextProjectsPage);
        let newProjectSearchOptions = _.cloneDeep(projectSearchOptions);
        newProjectSearchOptions.clearFilters();
        newProjectSearchOptions.addPaging(1, 50);
        if (typeof projectSearchTerm === 'string') {
            const fieldValues = projectSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[CL_NO]', ODataFilterOperators.Equals, !!projectSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined && !isNaN(Number(fieldValues[1]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[PR_NO]', ODataFilterOperators.Equals, !!projectSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined && !isNaN(Number(fieldValues[2]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[PR_NAME]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined && !isNaN(Number(fieldValues[3]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[TSD_MGR]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined && !isNaN(Number(fieldValues[4]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[PROJECT_COORDINATOR]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[4] : ''));
            }
            if (fieldValues[5] !== undefined && !isNaN(Number(fieldValues[5]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[OFFICE]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[5] : ''));
            }
        }
        setProjectSearchOptions(newProjectSearchOptions);
    };

    const displayProjectSettingButtons = () => {
        return (
            <>
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Find Project"
                    reactIcon={BsSearch}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => findProject(false)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to First Project"
                    reactIcon={BiArrowToLeft}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToFirstProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Previous Project"
                    reactIcon={BiLeftArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToPreviousProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Add New Project"
                    reactIcon={BiAddToQueue}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                    onClick={() => setAddingProject(true)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Delete Project"
                    reactIcon={FaTrash}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => deleteProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Save Project Changes"
                    reactIcon={FaRegSave}
                    type={'button'}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => onSaveChanges()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Next Project"
                    reactIcon={BiRightArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToNextProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Last Project"
                    reactIcon={BiArrowToRight}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToLastProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Change Manager"
                    reactIcon={FaUserTie}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => findManager()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Manager Change History"
                    reactIcon={FaUserTie}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => showManagerChangeHistory()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="PCM Change History"
                    reactIcon={MdHistory}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => showApmChangeHistory()}
                />
            </>
        );
    };

    const displayProjectSettings = () => {
        return (
            <>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'#'}
                    labelOnLeft={true}
                    name={'number'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                    readOnly={true}
                />
                <RHFInputBox
                    label={'Name'}
                    labelOnLeft={true}
                    name={'name'}
                    register={register}
                />
                <RHFInputBox
                    label={'Manager'}
                    labelOnLeft={true}
                    name={'manager'}
                    register={register}
                    readOnly={true}
                    onDoubleClick={() => findManager()}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'managerName'}
                    register={register}
                    readOnly={true}
                    onDoubleClick={() => findManager()}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Mileage Rate:'}
                    labelOnLeft={true}
                    name={'mileageRate'}
                    register={register}
                    style={{width: '40%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '80%' }}
                />
                <RHFInputBox
                    label={'Client ref #'}
                    labelOnLeft={true}
                    name={'clientReferenceNo'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFCheckbox
                    style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                    labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                    checked={applyBdBonus}
                    register={register}
                    onChange={() => setApplyBdBonus(!applyBdBonus)}
                    bodyStyle={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                    errors={errors}
                    label={'BD Bonus?'}
                    name={'bdBonus'}
                />
                <RHFInputBox
                    label={'BDM:'}
                    labelOnLeft={true}
                    name={'bizDevMgr'}
                    register={register}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'bizDevMgrName'}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFSelect
                    label={`Client Townships`}
                    name={`easternTownship`}
                    options={[
                        { value: '0', label: 'Load Townships' }
                    ]}
                />
                <RHFInputBox
                    label={'AFE #:'}
                    labelOnLeft={true}
                    name={'afeNumber'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Crew Chief'}
                    labelOnLeft={true}
                    name={'crewChiefNo'}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'crewChiefName'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                {officeOptionValues && <RHFSelect
                    labelOnLeft={true}
                    label="Base Office:"
                    name={`managingOffice`}
                    options={officeOptionValues?.map(o => {
                        return { value: o.code, label: o.description };
                        })}
                    register={register}
                    errors={errors}
                    style={{ width: '100%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />}
                <RHFSelect
                    label={`Client Landman Reporting`}
                    name={`clientLandmanUse`}
                    register={register}
                    options={[
                        { value: 0, label: 'None' },
                        { value: 1, label: 'CALMS' },
                        { value: 2, label: 'Lease Records' },
                        { value: 3, label: 'Both' },
                    ]}
                />
                <RHFInputBox
                    label={'PC / APM'}
                    labelOnLeft={true}
                    name={'projectCoord'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'projectCoordName'}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                {projectTypes && <RHFSelect
                    labelOnLeft={true}
                    label="Project Type:"
                    name={`type`}
                    options={projectTypes?.map(ct => {
                        return { value: ct.code, label: ct.description };
                        })}
                    register={register}
                    errors={errors}
                    style={{ width: '100%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />}
                <RHFSelect
                    label="Hide on Invoice?"
                    name="hideProspectOnInvoice"
                    register={register}
                    options={[
                        { value: 0, label: 'Do not Hide' },
                        { value: 1, label: 'Hide' },
                        { value: 2, label: 'Hide County' },
                        { value: 3, label: 'Hide Prospect & County' },
                    ]}
                />
                <RHFInputBox
                    label={'Client Contact'}
                    labelOnLeft={true}
                    name={'clientContact'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'clientContactName'}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Approximate Comp Date'}
                    labelOnLeft={true}
                    name={'completionDate'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFSelect
                    label="Commission Split"
                    name={'splitOmp'}
                    register={register}
                    options={[
                        { value: '0', label: 'None' },
                        { value: '1', label: '25%' },
                        { value: '2', label: '33%' },
                        { value: '3', label: '50%' },
                        { value: '4', label: '67%' },
                        { value: '5', label: '75%' }
                    ]}
                />
                <RHFInputBox
                    label={'A/P Contact No'}
                    labelOnLeft={true}
                    name={'clientApContactNo'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'clientApContactName'}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'District'}
                    labelOnLeft={true}
                    name={'district'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Project'}
                    labelOnLeft={true}
                    name={'project'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Well Name'}
                    labelOnLeft={true}
                    name={'wellName'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'ASR Beginning Services/Expenses'}
                    labelOnLeft={true}
                    name={'project'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Attached Documents'}
                    labelOnLeft={true}
                    name={'attachedDocuments'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
            </div>
            </>
        );
    };

    const AddProjectAndHideDialog = (payload: ProspectDetails) => {
        addProject(payload);
        hideDialog();
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const findClient = () => {
        showDialog(DialogList.FIND_CLIENT);
    };

    const findProject = (addNewProject: boolean) => {
        if (!!addNewProject) {
            setAddingProject(true);
        } else {
            setAddingProject(false);
            showDialog(DialogList.FIND_PROJECT);
        }
    };

    const onSubmit = () => {
        console.log('onSubmit called for save project');
    };

    const onSubmitCounties = (formData: { addCounties: Array<County> }) => {
        setCountiesForUpdate(formData?.addCounties ? formData?.addCounties : []);
    };

    const findManager = () => {
        showDialog(DialogList.FIND_MANAGER);
    };

    const showManagerChangeHistory = () => {
        alert('Implement manager change history dialog');
    };

    const showApmChangeHistory = () => {
        alert('Implement APM change history dialog');
    };

    const reportOptions = () => {
        alert('Implement report options');
    };

    const findPerson = () => {
        alert('Implement report options');
    };

    const moveToFirstProject = () => {
        if (!!projects && projects?.length > 1) {
            setSelectedProject(projects[0]);
        }
    };

    const moveToNextProject = () => {
        alert('Implement move to next project');
    };

    const moveToLastProject = () => {
        if (!!projects && projects?.length > 1) {
            setSelectedProject(projects[projects.length - 1]);
        }
    };

    const getStateNameFromId = (id: number) => {
        return (states.items.find(s => s.id === id))?.name;
    };

    const getOfficeIdString = (label: string) => {
        if (Array.isArray(offices)) {
            return offices.find(o => o.office === label)?.id.toString();
        } else {
            return '';
        }
    };

    const initializeManagerSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const managerSearchOptions = ODataOptions.from(tableConfig);
        managerSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const currentDate = new Date();
        const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        currentDate.setMonth(new Date().getMonth());
        const endDate = new Date(currentDate.setMonth(currentDate.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        managerSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate));
        managerSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate));

        return managerSearchOptions.toString();
    };

    const getManagers = async () => {
        const queryString = initializeManagerSearchSettings();
        let result = await get(`/v1.0/ClientProjectMaintenance/project/managers${queryString}`);

        if (response.ok) {
            setManagers(result);
        } else {
            console.log('Unable to get manager data!!!');
        }
    };

    const showToast = (message: string, color?: string, persistent?: boolean) => {
        setToast({ message, persistent, color });
    };

    const handleSelectedManager = (newManager: Landman) => {
        if (!isNaN(newManager?.lmsNumber) && newManager?.firstName && newManager?.lastName)  {
            setValue('manager', newManager.lmsNumber);
            setValue('managerName', newManager?.firstName + ' ' + newManager?.lastName);
        }
    };

    const getOfficeLabel = (id: number) => {
        if (Array.isArray(offices)) {
            return offices.find(o => o.id === id)?.office;
        } else {
            return '';
        }
    };

    const generateUpdatePayload = () => {
        const tsdiCounties = countiesForUpdate.map(c => {
            return ({ county: c.name, state: getStateNameFromId(selectedState) });
        });
        const stateString = Array.isArray(states?.items) ? states?.items.find((s) => s.id === selectedState )?.name : '';
        const projectFormData = getValues() as ProspectDetails;
        const payload: Partial<ProspectDetails> = {
            id: !isNaN(Number(selectedProject?.id)) ? Number(selectedProject.id) : null,
            clientNumber: !isNaN(Number(selectedClient?.clientNumber)) ? Number(selectedClient?.clientNumber) : null,
            name: projectFormData?.name ?? null,
            number: projectFormData?.number && !isNaN(Number(projectFormData?.number)) ? Number(projectFormData?.number) : null,
            county: projectFormData?.county || null,
            dayRate: projectFormData?.dayRate && !isNaN(Number(projectFormData?.dayRate)) ? Number(projectFormData?.dayRate) : null,
            clientContact: projectFormData?.clientContact && !isNaN(Number(projectFormData?.clientContact)) ? Number(projectFormData.clientContact) : null,
            clientContactName: projectFormData?.clientContactName || null,
            mileageRate: projectFormData?.mileageRate && !isNaN(Number(projectFormData?.mileageRate)) ? Number(projectFormData?.mileageRate) : null,
            manager: projectFormData?.manager && !isNaN(Number(projectFormData?.manager)) ? projectFormData.manager.toString() : null,
            managerName: projectFormData?.managerName || null,
            clientReferenceNo: projectFormData?.clientReferenceNo || null,
            managingOffice: !isNaN(Number(projectFormData?.managingOffice)) ? getOfficeLabel(Number(projectFormData.managingOffice)) : null,
            bizDevMgr: projectFormData?.bizDevMgr && !isNaN(Number(projectFormData?.bizDevMgr)) ? Number(projectFormData?.bizDevMgr) : null,
            bizDevMgrName: projectFormData?.bizDevMgrName || null,
            crewChief: projectFormData?.crewChief && !isNaN(Number(projectFormData?.crewChief)) ? Number(projectFormData.crewChief) : null,
            crewChiefName: projectFormData?.crewChiefName || null,
            bdBonus: projectFormData?.bdBonus || null,
            turnkey: projectFormData?.turnkey || null,
            type: projectFormData?.type || null,
            afeNumber: projectFormData?.afeNumber || null,
            district: projectFormData?.district || null,
            creationDate: projectFormData?.creationDate || null,
            completionDate: projectFormData?.completionDate || null,
            project: projectFormData?.project || null,
            splitOmp:  projectFormData?.splitOmp ? projectFormData.splitOmp : null,
            projectCoord: projectFormData?.projectCoord && !isNaN(Number(projectFormData?.projectCoord)) ? Number(projectFormData.projectCoord) : null,
            projectCoordName: projectFormData?.projectCoordName || null,
            wellName: projectFormData?.wellName || null,
            easternTownship: projectFormData?.easternTownship || null,
            beginningServices: projectFormData?.beginningServices && !isNaN(Number(projectFormData?.beginningServices)) ? Number(projectFormData?.beginningServices) : null,
            hideProspectOnInvoice: projectFormData?.hideProspectOnInvoice && !isNaN(Number(projectFormData?.hideProspectOnInvoice)) ? Number(projectFormData?.hideProspectOnInvoice) : null,
            clientLandmanUse: projectFormData?.clientLandmanUse && !isNaN(Number(projectFormData?.clientLandmanUse)) ? Number(projectFormData?.clientLandmanUse) : null,
            clientApContactNo: projectFormData?.clientApContactNo && !isNaN(Number(projectFormData?.clientApContactNo)) ? Number(projectFormData?.clientApContactNo) : null,
            clientApContactName: projectFormData?.clientApContactName || null,
            attachedDocuments: projectFormData?.attachedDocuments && !isNaN(Number(projectFormData?.attachedDocuments)) ? Number(projectFormData?.attachedDocuments) : null,
            backupOfficeRate: projectFormData?.backupOfficeRate && !isNaN(Number(projectFormData?.backupOfficeRate)) ? Number(projectFormData?.backupOfficeRate) : null,
            billMode: projectFormData?.billMode || null,
            billBy: projectFormData?.billBy || null,
            bopRate: projectFormData?.bopRate && !isNaN(Number(projectFormData?.bopRate)) ? Number(projectFormData?.bopRate) : null,
            state: stateString || null,
            modByName: projectFormData?.modByName || null,
            modByNo: projectFormData?.modByNo && !isNaN(Number(projectFormData?.modByNo)) ? Number(projectFormData?.modByNo) : null,
            counties: Array.isArray(tsdiCounties) ? tsdiCounties : []
        };

        return payload as ProspectDetails;
    };

    const onSaveChanges = () => {
        saveCountiesRef.click();
    };

    const moveToPreviousProject = () => {
        alert('Implement move to previous project');
    };

    const generateReports = () => {
        alert('Implement move to previous project');
    };

    const runQuery = () => {
        alert('Run query for client and project');
    };

    const getDayRate = () => {
        let dayRate = 250.00;
        if (!!addingProject) {
            if (!!selectedClient && !!selectedClient?.dayRate) {
                dayRate = selectedClient.dayRate;
            }
        }
        return dayRate;
    };

    const displayCounties = () => {
        return (
            <>
                <table>
                    <thead>
                        <td>
                            State
                        </td>
                        <td>
                            County
                        </td>
                    </thead>
                    <tbody>
                    {selectedProject?.counties?.map((c, index) =>
                        <tr key={index}>
                            <td>
                                {c?.state}
                            </td>
                            <td>
                                {c?.county}
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </>);
    };

    return (
        <>
        <div>
        <CPNavBar/>
        <div>
            {toast && (
                <PersonnelToast
                    message={toast.message}
                    color={toast.color}
                    onClose={() => setToast(null)}
                    persistent={toast.persistent}
                />
            )}
        </div>
        <ClientProjectSearch
            selectedClient={selectedClient}
            selectedProject={selectedProject?.number}
            setSelectedClient={setSelectedClient}
            setSelectedProject={setSelectedProject}
            clients={clients}
            projects={true}
            runQuery={runQuery}
            size={6}
        />
           <div style={{display: 'flex', width: '100vw', justifyContent: 'center'}}>
                <form id={`ProjectMaintenanceForm`} onSubmit={onSubmit}>
                <Page className="dlc-maxer-width">
                        <Page.Section width={12}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <RHFInputBox
                                                name={'clientNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '15%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'clientName'}
                                                style={{width: '100%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Client"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Landman"
                                                iconImage={`findLandman.png`}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '22px', height: '22px', verticalAlign: 'center'}}
                                                onClick={() => findPerson()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Client"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findProject(true)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToFirstProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToPreviousProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToNextProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToLastProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Billing Accounts"
                                                reactIcon={FaFileAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => generateReports()}
                                            />
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={FaUserTie}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => window.print()}
                                            />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={12}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayHeading2()}>
                                    <div style={{marginBottom: '1rem', display: 'flex', width: '100%', justifyContent: 'center'}}>
                                        {displayProjectSettingButtons()}
                                    </div>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                        {displayProjectSettings()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={12}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={'Counties'}>
                                    <div style={{display: 'flex', width: '100%', justifyContent: 'left'}}>
                                    <Form
                                        onSubmit={onSubmitCounties}
                                        mutators={{ ...arrayMutators }}
                                        render={({ handleSubmit, form }) => {
                                            return (
                                                <form onSubmit={handleSubmit}>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                        <div style={{ display: 'flex', gap: '2rem', width: '98%' }}>
                                                            {selectStates && <RHFSelect
                                                                label="State"
                                                                name="stateId"
                                                                options={selectStates}
                                                                defaultVal={'Select State'}
                                                                onChange={(e) => onStateSelected(Number(e.currentTarget.value))}
                                                                style={{ width: '100%' }}
                                                                register={registerState}
                                                                bodyStyle={{ width: '30%' }}
                                                            />}
                                                            <TagContainer
                                                                label="Counties"
                                                                isTagCreatable={false}
                                                                fieldArrayName="counties"
                                                                fieldAddArrayName="addCounties"
                                                                fieldDeleteArrayName="deleteCounties"
                                                                initialValueName="county"
                                                                form={form}
                                                                selectTags={selectStateCounties ? selectStateCounties : new Array<SelectItem>()}
                                                            />
                                                            <div style={{display: 'flex', justifyContent: 'center', width: '20vw' }}>
                                                                {displayCounties()}
                                                            </div>
                                                            <Button
                                                                style={{display: 'none'}}
                                                                id={'saveCountiesButton'}
                                                                type={'submit'}
                                                                text={'Save Counties'}
                                                            />
                                                        </div>
                                                    </div>
                                                </form>
                                            );
                                        }}
                                    />
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
            </div>
        </div>
            <FindManagerDialog
                dialogName={DialogList.FIND_MANAGER}
                hideDialog={hideDialog}
                populateManagerList={getManagers}
                managerList={managers}
                handleSelectedManager={handleSelectedManager}
            />
            <FindClientDialog
                dialogName={DialogList.FIND_CLIENT}
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                setSelectedClient={setSelectedClient}
            />
            <FindProjectDialog
                billByOptions={billByOptions}
                dialogName={DialogList.FIND_PROJECT}
                hideDialog={hideDialog}
                setProjectSearchTerm={setProjectSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                addNewProject={addingProject}
                setSelectedProject={setSelectedProject}
                setSelectedClient={setSelectedClient}
                mileageRate={currentMileageRate}
                onAddNewProject={AddProjectAndHideDialog}
                clientNumber={selectedClient?.clientNumber}
                dayRate={getDayRate()}
                clientTypes={projectTypes}
                offices={Array.isArray(offices) ? offices.map((o, index) => { return { value: index, label: o.office}; }) : [] }
                managers={Array.isArray(managers) ? managers.map((m) => { return { value: m.lmsNumber, label: '(' + m.lmsNumber + ') ' + m.firstName + ' ' + m.lastName}; }) : [] }
            />
        </>
    );
};

export default ProjectMaintenancePage;



// WEBPACK FOOTER //
// ./src/components/client-project/pages/ProjectMaintenancePage.tsx